import { mtLangResolved } from '@/app/modules/Criticals/MtLang';
import { Languages } from './types';

// при смене дефолтного языка не забудь в inbuiltMessages.ts поправить импортируемые переводы
// @TODO: DEFAULT_LANGUAGE env не будет работать, см ^^
/**
 * Язык приложения
 */
export const DEFAULT_LANGUAGE: Languages = Languages.ru;

/**
 * Международный язык
 */
export const INTERNATIONAL_LANGUAGE: Languages = Languages.en;

/**
 * Язык, определённый нашими средствами
 */
export const RESOLVED_LANGUAGE =
    Languages[mtLangResolved as Languages] || INTERNATIONAL_LANGUAGE;

/**
 * Fallback
 * TODO need? https://kazupon.github.io/vue-i18n/guide/fallback.html#explicit-fallback-with-an-array-of-locales
 */
export const FALLBACK_LOCALE = DEFAULT_LANGUAGE;
